import React, { useEffect, useState } from 'react'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../utils/Enum';
import Loader from '../../../shared/Loader/Loader';
import isNull from '../../../../utils/NullChecking';
import BillingRightMenu from './BillingRightMenu';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { FindSecondChild } from '../../../../utils/FindMenuOption';


const BillingRights = (props) => {
    const API_URL = enumUtil.controller.MenuOption
    let IsEditAllowed = FindSecondChild('Setup', 'User Management', 'Roles')?.IsAdd

    const { handleOpenRole, RoleID, userID, handleSaveUserRoles, type, isUserSaved, isCustomRole } = { ...props }
    const [isLoading, setIsLoading] = useState(false);
    const [EndMenuItems, setEndMenuItems] = useState([])
    const [MenuOptions, setMenuOptions] = useState([])
    const [activeMenuKey, setActiveMenuKey] = useState('1')
    const [activeMenuName, setActiveMenuName] = useState('Home')
    const [subActiveMenukey, setsubActiveMenukey] = useState('')
    const [isRoleSaved, setisRoleSaved] = useState()
    const [SelectAll, setSelectAll] = useState(false)

    const [isViewAll, setIsViewAll] = useState(false);
    const [isAddAll, setIsAddAll] = useState(false);
    const [isDeleteAll, setIsDeleteAll] = useState(false);
    let Roles_Modal = {
        RoleID: '',
        RoleRightID: '',
        MenuOptionID: '',
        ISView: '',
        IsAdd: '',
        IsDeleted: ''
    }
    let User_Modal = {
        UserID: '',
        UserRightsID: '',
        MenuOptionID: '',
        ISView: '',
        IsAdd: '',
        IsDeleted: ''
    }
    const [RolesSaveModal, setRolesSaveModal] = useState([])
    useEffect(() => {
        if (!isNull(RoleID)) {
            setIsLoading(true);
            ServerRequestProtected(API_URL + "/FindMenuOption", 'post', {
                "TableName": enumUtil.enumAPITableName.Roles,
                "ID": RoleID
            }).then((response) => {
                setRolesSaveModal([])
                setMenuOptions(response)
                handleCheckBoxoNMenuChange(response[0].Children)
                setEndMenuItems(response[0].Children)
                setActiveMenuKey(response[0].MenuOptionID)
                setActiveMenuName(response[0].MenuName)
                setsubActiveMenukey('')
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
            })
        }
    }, [RoleID, isRoleSaved])
    useEffect(() => {
        // User ID case
        if (!isNull(userID)) {
            setIsLoading(true);
            ServerRequestProtected(API_URL + "/FindMenuOption", 'post', {
                "TableName": enumUtil.enumAPITableName.Roles,
                "ParentID": userID
            }).then((response) => {
                setRolesSaveModal([])
                setMenuOptions(response)
                setEndMenuItems(response[0].Children)
                setActiveMenuKey(response[0].MenuOptionID)
                setActiveMenuName(response[0].MenuName)
                setsubActiveMenukey('')
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
            })
        }
    }, [userID, isUserSaved])
    const handleCheckboxChange = (data, index, menuname) => {
        setSelectAll(false)
        setsubActiveMenukey(data.MenuOptionID)
        setActiveMenuKey(data.ParentID)
        setActiveMenuName(menuname + ' -> ' + data.MenuName)
        setEndMenuItems(data.Children)
        handleCheckBoxoNMenuChange(data.Children)
    }
    const handleOpenRights = (data, index) => {
        setIsViewAll(false)
        setIsAddAll(false)
        setIsDeleteAll(false)
        setSelectAll(false)
        setActiveMenuKey(data.MenuOptionID)
        console.log(data, 'dataSelectedRole');
        if (data.Children[0].Children.length === 0) {
            handleCheckBoxoNMenuChange(data.Children)
            setEndMenuItems(data.Children)
            setsubActiveMenukey('')
            setActiveMenuName(data.MenuName)
        } else {
            handleCheckBoxoNMenuChange(data.Children[0].Children)
            setEndMenuItems(data.Children[0].Children)
            setsubActiveMenukey(data.Children[0].MenuOptionID)
            setActiveMenuName(data.MenuName + '→' + data.Children[0].MenuName)
        }
    }
    const handleCheckBoxoNMenuChange = (data) => {
        data.map((item) => {
            if (item.ISView === false) {
                setIsViewAll(false)
            } else {
                setIsViewAll(true)
            }
            if (item.IsAdd === false) {
                setIsAddAll(false)
            } else {
                setIsAddAll(true)
            }
            if (item.IsDeleted === false) {
                setIsDeleteAll(false)
            } else {
                setIsDeleteAll(true)
            }
            if (item.ISView === false || item.IsAdd === false || item.IsDeleted === false) {
                setSelectAll(false)
            } else {
                setSelectAll(true)
            }
        })
    }
    const handleChangeMenuOptions = (e, data, index) => {
        let { name, checked } = e.target
        let menu = [...MenuOptions]
        let newData = { ...data }
        // debugger
        for (let i = 0; i < menu.length; i++) {
            const item = menu[i];
            if (item.ParentID === data.ParentID) {
                const children = item.Children;
                for (let j = 0; j < children.length; j++) {
                    const fchild = children[j];
                    if (fchild.Children.length === 0) {
                        item.Children[index][name] = checked;
                        break; //need to review this condition
                    } else {
                        if (fchild.ChildID === data.ChildID) {
                            fchild.Children[index][name] = checked;
                            break;
                        }
                    }
                }
            }
        }
        setMenuOptions(menu)
        let endmenucopy = [...EndMenuItems]
        endmenucopy[index][name] = checked
        setEndMenuItems(endmenucopy)
        let newlist = [...RolesSaveModal]
        let modal = isNull(RoleID) ? { ...User_Modal } : { ...Roles_Modal }
        let newcaseiflengreaterthanzero = false
        if (RolesSaveModal.length === 0) {
            modal.MenuOptionID = newData.MenuOptionID
            if (isNull(RoleID)) {
                modal.UserID = isNull(newData.UserID) ? userID + "" : newData.UserID
                modal.UserRightsID = isNull(newData.UserRightsID) ? '' : newData.UserRightsID
            } else {
                modal.RoleID = isNull(newData.RoleID) ? RoleID + "" : newData.RoleID
                modal.RoleRightID = isNull(newData.RoleRightID) ? '' : newData.RoleRightID
            }
            modal.ISView = newData.ISView + ""
            modal.IsAdd = newData.IsAdd + ""
            modal.IsDeleted = newData.IsDeleted + ""
            modal[name] = checked + "";
            newlist.push(modal)
        } else {
            for (let i = 0; i < RolesSaveModal.length; i++) {
                const item = RolesSaveModal[i];
                if (item.MenuOptionID === newData.MenuOptionID) {
                    item.MenuOptionID = newData.MenuOptionID;
                    if (isNull(RoleID)) {
                        item.UserID = isNull(newData.UserID) ? userID + "" : newData.UserID;
                        item.UserRightsID = isNull(newData.UserRightsID) ? '' : newData.UserRightsID;
                    } else {
                        item.RoleID = isNull(newData.RoleID) ? RoleID + "" : newData.RoleID;
                        item.RoleRightID = isNull(newData.RoleRightID) ? '' : newData.RoleRightID;
                    }
                    item.ISView = newData.ISView + "";
                    item.IsAdd = newData.IsAdd + "";
                    item.IsDeleted = newData.IsDeleted + "";
                    item[name] = checked + "";
                    newcaseiflengreaterthanzero = false;
                    break;
                } else {
                    newcaseiflengreaterthanzero = true;
                }
            }
        }
        if (newcaseiflengreaterthanzero === true) {
            modal.MenuOptionID = newData.MenuOptionID
            if (isNull(RoleID)) {
                modal.UserID = isNull(newData.UserID) ? userID + "" : newData.UserID
                modal.UserRightsID = isNull(newData.UserRightsID) ? '' : newData.UserRightsID
            } else {
                modal.RoleID = isNull(newData.RoleID) ? RoleID + "" : newData.RoleID
                modal.RoleRightID = isNull(newData.RoleRightID) ? '' : newData.RoleRightID
            }
            modal.ISView = newData.ISView + ""
            modal.IsAdd = newData.IsAdd + ""
            modal.IsDeleted = newData.IsDeleted + ""
            modal[name] = checked + ""
            newlist.push(modal)
        }
        setRolesSaveModal(newlist)
        if (!isNull(handleSaveUserRoles)) {
            handleSaveUserRoles(newlist)

        }
    }
    function flattenMenuOptions(menuOptions) {
        const flatMenuOptions = [];

        function flatten(menuOption) {
            // Extract only the specified fields
            const flattenedMenuOption = {
                ISView: menuOption.ISView + "",
                IsAdd: menuOption.IsAdd + "",
                IsDeleted: menuOption.IsDeleted + "",
                MenuOptionID: menuOption.MenuOptionID,
                RoleID: isNull(menuOption.RoleID) ? RoleID + "" : menuOption.RoleID,
                RoleRightID: menuOption.RoleRightID
            };

            // Push the flattened menu option to the flat array
            flatMenuOptions.push(flattenedMenuOption);

            // If the current menu option has children, recursively flatten them
            if (menuOption.Children && menuOption.Children.length > 0) {
                menuOption.Children.forEach(child => {
                    flatten(child);
                });
            }
        }

        // Start flattening from the top-level menu options
        menuOptions.forEach(menuOption => {
            flatten(menuOption);
        });

        return flatMenuOptions;
    }


    const handleSaveRoles = () => {
        // Example usage
        const flatMenuOptions = flattenMenuOptions(MenuOptions);
        let saveModal = {
            TableName: enumUtil.enumAPITableName.Roles,
            Data: flatMenuOptions
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/SaveMenuOptions", 'post', saveModal)
            .then((response) => {
                NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                setIsLoading(false)
                setisRoleSaved((Math.random()))
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
    }

    const getUpdatedItem = (item, type, checked) => {
        if (type) {
            return { ...item, [type]: checked };
        } else {
            return {
                ...item,
                ISView: checked,
                IsAdd: checked,
                IsDeleted: checked,
                IsEnable: checked,
            };
        }
    };

    const handleSelectAll = (e, type) => {
        const checked = e.target.checked;
        if (isNull(type)) {
            setSelectAll(checked);
            setIsViewAll(checked);
            setIsAddAll(checked);
            setIsDeleteAll(checked);
        }
        if (type === 'ISView') {
            setIsViewAll(checked);
        } else if (type === 'IsAdd') {
            setIsAddAll(checked);
        } else if (type === 'IsDeleted') {
            setIsDeleteAll(checked);
        }
        // Update MenuOptions
        const updatedMenu = MenuOptions.map((item) => {
            if (item.ParentID === activeMenuKey && item.Children.length > 0) {
                return {
                    ...item,
                    Children: item.Children.map((fchild) => {
                        if (fchild.Children.length > 0) {
                            return {
                                ...fchild,
                                Children: fchild.Children.map((schild) =>
                                    schild.ChildID === subActiveMenukey
                                        ? getUpdatedItem(schild, type, checked)
                                        : schild
                                )
                            };
                        } else {
                            return getUpdatedItem(fchild, type, checked);
                        }
                    })
                };
            }
            return item;
        });
        setMenuOptions(updatedMenu);

        // Update EndMenuItems
        const updatedEndMenu = EndMenuItems.map((item) =>
            item.ParentID === activeMenuKey
                ? getUpdatedItem(item, type, checked)
                : item
        );
        setEndMenuItems(updatedEndMenu);
    };
    const getMenuIconClass = (menuName) => {
        switch (menuName) {
            case "Home":
                return "bi bi-house-fill fs-11";
            case "Scheduler":
                return "icon-SCHEDULER fs-11";
            case "Patient":
                return "icon-PATIENTT fs-11";
            case "Billing":
                return "icon-BILLING fs-11";
            case "Reports":
                return "icon-REPORTS fs-11";
            case "Setup":
                return "icon-SETUP fs-11";
            case "Utilities":
                return "icon-UTILITIES fs-11";
            case "Support":
                return "icon-SUPPORT";
            case "CareGiver":
                return "icon-caregiver-1 fs-11";
            case "Encounter":
                return 'icon-encounter-menu fs-11'
            case "Support":
                return 'icon-SUPPORT fs-11'
            case "Miscellaneous":
                return 'icon-miscellaneous- fs-11'
            default:
                return "icon-home fs-11";
        }
    };

    const [openMenuKeys, setOpenMenuKeys] = useState([]); // keep track of open parents

    const toggleMenu = (menuId) => {
        setOpenMenuKeys((prev) =>
            prev.includes(menuId) ? prev.filter((id) => id !== menuId) : [...prev, menuId]
        );
    };
    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className='assigned-profiles p-2 hover-scrollbar'>
                <p className='heading fs-14 mb-2'> Assigned Roles</p>
                <div className='d-flex flex-column gap-12'>
                    {MenuOptions.map((item, index) => {
                        const isOpen = openMenuKeys.includes(item.MenuOptionID);

                        return (
                            <React.Fragment key={item.MenuOptionID}>
                                {/* Parent */}
                                <div
                                    className={`d-flex align-items-center gap-6 assign-content ${activeMenuKey === item.MenuOptionID ? "active" : ""
                                        }`}
                                    onClick={() => {
                                        handleOpenRights(item, index); // your existing function
                                        toggleMenu(item.MenuOptionID); // toggle children
                                    }}
                                >
                                    <i className={`${getMenuIconClass(item.MenuName)}`}></i>
                                    <p className="text fs-13">{item.MenuName}</p>
                                </div>

                                {/* Children (only if toggled open) */}
                                {isOpen && item.Children && item.Children.length > 0 && (
                                    <div className="child-content d-flex flex-column gap-2">
                                        {item.Children.map((Fchild, findex) =>
                                            Fchild.Children && Fchild.Children.length > 0 ? (
                                                <p
                                                    key={Fchild.MenuOptionID}
                                                    className={`text options ${subActiveMenukey === Fchild.MenuOptionID ? "active" : ""
                                                        }`}
                                                    onClick={() =>
                                                        handleCheckboxChange(Fchild, index, item.MenuName)
                                                    }
                                                >
                                                    {Fchild.MenuName}
                                                </p>
                                            ) : null
                                        )}
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })}

                </div>
            </div>
            <div className="roles-main-content">

                <div className="d-flex align-items-center justify-content-between br-bottom-1px br-clr-light-light px-1-5 pb-1 my-1">
                    <div className="">
                        <label className="custom_check_box d-flex align-items-center gap-6">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="selectall"
                                id="selectall"
                                checked={SelectAll}
                                onChange={(e) => handleSelectAll(e, null)}
                            />
                            <p className="heading fs-13 lh-13"> {SelectAll ? 'Unselect All' : 'Select All'}</p>
                        </label>
                    </div>

                    <div className="ar_setting_screen p-0">
                        <div className="ar_content">
                            <div className="d-flex gap-6 align-items-center">
                                {isCustomRole ? null : <> <button className="btn m-0 larg-btn" >'Reset to default</button>
                                    <div className='ar_line'></div>
                                </>}
                                <button className={IsEditAllowed ? 'btn m-0 btn-orange small-btn' : 'btn btn-orange small-btn disabled'} onClick={handleSaveRoles}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" px-1">
                    <BillingRightMenu
                        EndMenuItems={EndMenuItems}
                        handleChangeMenuOptions={handleChangeMenuOptions}
                        handleSaveRoles={handleSaveRoles}
                        RoleID={RoleID}
                        handleSelectAll={handleSelectAll}
                        SelectAll={SelectAll}
                        activeMenuName={activeMenuName}
                        getMenuIconClass={getMenuIconClass}
                        isViewAll={isViewAll}
                        isAddAll={isAddAll}
                        isDeleteAll={isDeleteAll}
                    />
                </div>

            </div>

            {/* {EndMenuItems && EndMenuItems.length > 0 ?
                <div className={`${type === 'User' ? 'col-md-9' : 'col-md-8'} role_third mt-4`}>
                    <div className='d-flex mt-1 align-items-center justify-content-between'>
                        <p className='third_heading ms-4'> {activeMenuName}</p>
                    </div>
                    <div className='d-flex align-items-center'>
                        <i className='icon-Icon-material-swap-vert me-1'></i>
                        <div className='bg_blue mt-1 mb-3 w-100'>
                            <BillingRightMenu EndMenuItems={EndMenuItems} handleChangeMenuOptions={handleChangeMenuOptions} handleSaveRoles={handleSaveRoles} RoleID={RoleID} handleSelectAll={handleSelectAll} SelectAll={SelectAll} />
                        </div>
                    </div>
                </div>
                : null} */}

        </>
    )
}

export default BillingRights